import { EmptyState } from "@nymbl/nos2-rules";
import { SlidersHorizontal } from "lucide-react";
import { SettingsPage } from "@/components/layout/SettingsPage";

export function SettingsSystemPage() {
  return (
    <SettingsPage>
      <div className="rounded-lg border bg-card">
        <EmptyState
          icon={SlidersHorizontal}
          title="System settings"
          description="System configuration options will be available here soon."
          headingLevel={2}
        />
      </div>
    </SettingsPage>
  );
}
